var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"dropdown-item"},_vm.$listeners),[_c('p',[_vm._t("default")],2),_c('transition',{attrs:{"name":"fade"}},[(_vm.contain)?_c('Icon',{staticClass:"done",attrs:{"type":"done","color":"#e81948","size":"14px"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }